import React from 'react';
import { createRoot } from 'react-dom/client';
import videojs from 'video.js';
import { FaPlay } from '@react-icons/all-files/fa/FaPlay';
import { FaPause } from '@react-icons/all-files/fa/FaPause';
import { FaVolumeUp } from '@react-icons/all-files/fa/FaVolumeUp';
import { FaVolumeDown } from '@react-icons/all-files/fa/FaVolumeDown';
import { FaVolumeMute } from '@react-icons/all-files/fa/FaVolumeMute';
import { FaExpand } from '@react-icons/all-files/fa/FaExpand';
import { FaCompress } from '@react-icons/all-files/fa/FaCompress';

export const replaceVideoJsIcons = (player: ReturnType<typeof videojs>) => {
    const bigPlayButton = player.el().querySelector('.vjs-big-play-button .vjs-icon-placeholder');
    if (bigPlayButton) {
        const root = createRoot(bigPlayButton);
        root.render(React.createElement(FaPlay, { style: { width: '100%', height: '100%' } }));
    }

    // Replace play/pause control icon
    const playControl = player.el().querySelector('.vjs-play-control .vjs-icon-placeholder');
    if (playControl) {
        const updatePlayIcon = () => {
            const root = createRoot(playControl);
            root.render(React.createElement(player.paused() ? FaPlay : FaPause, { style: { width: '100%', height: '100%' } }));
        };
        updatePlayIcon();
        player.on('play', updatePlayIcon);
        player.on('pause', updatePlayIcon);
    }

    // Replace volume control icon
    const volumeControl = player.el().querySelector('.vjs-volume-control .vjs-icon-placeholder');
    if (volumeControl) {
        const updateVolumeIcon = () => {
            const root = createRoot(volumeControl);
            const volume = player.volume() ?? 1;
            const muted = player.muted();
            let IconComponent;
            if (muted || volume === 0) {
                IconComponent = FaVolumeMute;
            } else if (volume < 0.5) {
                IconComponent = FaVolumeDown;
            } else {
                IconComponent = FaVolumeUp;
            }
            root.render(React.createElement(IconComponent, { style: { width: '100%', height: '100%' } }));
        };
        updateVolumeIcon();
        player.on('volumechange', updateVolumeIcon);
    }

    // Replace mute control icon
    const muteControl = player.el().querySelector('.vjs-mute-control .vjs-icon-placeholder');
    if (muteControl) {
        const updateMuteIcon = () => {
            const root = createRoot(muteControl);
            const volume = player.volume() ?? 1;
            const muted = player.muted();
            let IconComponent;
            if (muted || volume === 0) {
                IconComponent = FaVolumeMute;
            } else if (volume < 0.5) {
                IconComponent = FaVolumeDown;
            } else {
                IconComponent = FaVolumeUp;
            }
            root.render(React.createElement(IconComponent, { style: { width: '100%', height: '100%' } }));
        };
        updateMuteIcon();
        player.on('volumechange', updateMuteIcon);
    }

    // Replace fullscreen control icon
    const fullscreenControl = player.el().querySelector('.vjs-fullscreen-control .vjs-icon-placeholder');
    if (fullscreenControl) {
        const updateFullscreenIcon = () => {
            const root = createRoot(fullscreenControl);
            root.render(React.createElement(player.isFullscreen() ? FaCompress : FaExpand, { style: { width: '100%', height: '100%' } }));
        };
        updateFullscreenIcon();
        player.on('fullscreenchange', updateFullscreenIcon);
    }
};

